var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 351,
    height: 344,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:#e0e7f5}.s1,.s2{fill:none;stroke:#a6a5c7;stroke-linecap:round;stroke-width:3}.s2{stroke:#d8d8d8;stroke-linejoin:round;stroke-width:4}.s3{fill:#d8d8d8}.s4{fill:none;stroke:#969696;stroke-width:4}.s5{fill:#1f161e}.s6{fill:#000}.s7{fill:#969696}.s8{fill:#f8cdba}.s9{fill:#145c90}.s10{fill:#207bbd}.s11{fill:#2efff0}.s12{fill:#fbdc8e}.s13{fill:#69d2c9}.s14{fill:none;stroke:#1f161e;stroke-linecap:round;stroke-width:.6}.s15{fill:#fa9e9f}.s16{stroke:#1f161e;stroke-width:.7}.s16,.s17,.s18{fill:none;stroke-linecap:round}.s17{stroke:#969696;stroke-width:4}.s18{stroke:#1f161e;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M211.7 248.2H106.1l52.8-210.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "M143.7 248.2h-70l35-144.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "M108.7 149.4v98.8M158.9 97.8v150.4M108.7 186.3l9.3-9.3M108.7 226.4 94.2 212M158.9 140.8l-10.5-10.6M158.9 201.6l21.1-21.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m250.3 0 62.2 248.2H188.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m309.5 77.8 41.2 170.4h-82.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "M309.5 131.7v116.5M250.3 71v177.2M309.5 175.3l-11-11M309.5 222.5l17-17M250.3 121.6l12.4-12.4M250.3 193.3l-24.8-24.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "M152.1 305.2h40M152.1 308.4l39.2 11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M167.9 259.7c0-1.4 1.1-2.6 2.6-2.6h14.6c1.4 0 2.6 1.2 2.6 2.6 0 1.5-1.2 2.7-2.6 2.7h-14.6c-1.5 0-2.6-1.2-2.6-2.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m182.1 275.6 67.1.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M264.9 341.2c-18.2 0-32.8-14.7-32.8-32.8 0-18.2 14.6-32.8 32.8-32.8 18.1 0 32.8 14.6 32.8 32.8 0 18.1-14.7 32.8-32.8 32.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m264.9 308.4-22.5-46.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M192.5 320.8c-4.8 0-8.7-3.9-8.7-8.7 0-4.8 3.9-8.8 8.7-8.8 4.8 0 8.7 4 8.7 8.8 0 4.8-3.9 8.7-8.7 8.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M152.1 341.2c-18.2 0-32.8-14.7-32.8-32.8 0-18.2 14.6-32.8 32.8-32.8 18.1 0 32.8 14.6 32.8 32.8 0 18.1-14.7 32.8-32.8 32.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M187.5 317.6q-.2.5-.3.9-.1.5-.1 1t.1.9q.1.5.3 1c.5.5 4.2 2.5 4.6 2.9.3.4-.2 1.3-.9 1.6-.6.4-10.9-3-11.7-3.7-.8-.8 1.2-5.7 1.4-6.5M197.1 285.1q-.3.3-.5.7-.3.5-.5.9-.2.5-.2.9-.1.5-.1 1c.2.6 3 3.8 3.2 4.3.2.5-.7 1.2-1.4 1.3-.6.1-9.1-6.7-9.5-7.7-.5-1 3.1-4.9 3.6-5.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M254.2 216.7c-1.9 0-8.5-5.2-9.4-6.3-.8 2.8-13.3 1.7-14.1 10.8-1.4 0-41.9 3.3-44.8 3.3-3 0-15.4-2.5-15.4-16.1 0-5.4 4.6-19.5 19-19.5 11.2 0 21.5 9.3 30.3 9.3 10.3 0 16.4-5 25.9-5 9 0 19.2 7 19.2 14.8 0 2.8-2.2 8.7-10.7 8.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m246.7 258.3 4.5-2 .7 1.8-4.4 1.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m237 236.2-.2 2.2q-.1 1.1-.1 2.2-.1 1.1-.1 2.2v2.3l.2 1s5.8 10.1 6.3 10.9c.4.7-2.2 1.9-2.2 1.9s-10.3-10.8-11-11.7c-.7-.9-3.8-10.2-3.8-11.3.1-1.1 10.9.3 10.9.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "M205.7 235.4c.7.7 21.1 20.7 21 22.4-.2 1.8-27.9 26.3-31.1 27-3.2.7-.3-9.7.9-10.6q1.8-1.4 3.6-2.9t3.5-3q1.8-1.6 3.5-3.2t3.3-3.2c-2-1-23.2-12.2-26.4-13.5-3.1-1.3 21.7-13 21.7-13z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M199.8 275.1c-.2 2.2-12.1 42.8-12.1 42.8l-7.5-1.9s4.7-33.9 5.2-36.7c-2.1-5.7-8-26.1-8-40.1 0-7.8 3.8-14.3 9.7-19.2 1.1 6.3 5.9 15 12.7 19.2-.1 1.2 1.7 27.2 0 35.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M236 263.2c-4.5-2.2-22.2-10.2-23.5-14.7-2-7.4 8.4-28.4 9-29.6 0 0 11.2 11.7 8.9 13.9-2.4 2.1-6.8 9.9-7.8 12 2.1 4.4 14.7 12.8 15.6 13 1 .2.8 1 .8 1s1.5 6.6-3 4.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "M186.1 220.9c.3-.3.6-.6 1-.9q-.5.4-1 .9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "M239.2 217.7c0 1.5-2.1 17.9-2.4 19.4q-1.2.1-2.3.2h-2.4q-1.1-.1-2.3-.3-1.1-.1-2.3-.3v-.1c-.4.6-.8 1.3-1.1 1.8-.4-.1-8.1-4.4-11-6-.1.3-.2 1-.4 1.6-6.3 2.1-15.2 5.2-15.2 5.2-6.9-4.2-11.6-12.9-12.7-19.2 9.2-7.9 23.4-12 35.3-12 15.7 0 16.8 8.2 16.8 9.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m245.2 218.9-10.5 2c-1.5.3-2.9-7.2-1.5-7.5l10.5-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "M215.4 232.4c.6-1.4 3.3-9 4.9-11M226.4 238.4c.7-1.2 4.3-7.1 4.3-7.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M248.1 261.1c-.6 1.6-2.7 2.1-4.7 1.3-1.9-.9-2.9-2.8-2.2-4.3.6-1.6 2.7-2.1 4.7-1.3 1.9.9 2.9 2.8 2.2 4.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "M240.5 261.6c-.2-.5.1-1.1.6-1.3l2.7-1c.5-.2 1.1 0 1.3.5.2.5-.1 1.1-.6 1.3l-2.7 1c-.5.2-1.1 0-1.3-.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M243.3 262.1c-.4 2.2-2.8 3.5-5.5 3.1-2.7-.4-4.6-2.5-4.3-4.6.4-2.1 2.8-3.5 5.5-3 2.7.4 4.6 2.4 4.3 4.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m230.2 264.6 7.3-2.8q.1-.1.3-.1.2 0 .4.1t.3.2q.1.1.2.3.1.2.1.4t-.1.3q-.1.2-.2.3l-.3.3-7.3 2.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M247.1 212.9c-1.1 0-2.1-1-2.1-2.1 0-1.2 1-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1 0 1.1-.9 2.1-2.1 2.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M258.7 213.1c-.3 2.5-1.6 4.8-3.6 6.3-2 1.6-4.5 2.2-7 1.9-2.5-.4-4.7-1.8-6.2-3.8-1.5-2.1-2-4.6-1.6-7.1q1.1.1 2.2.1t2.2-.1q1.1-.1 2.1-.2l2.2-.4c2.2 1.3 7.1 2.8 9.7 3.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "M256.1 215.5c-.1.5-.4 3.4-2.5 2.4M249.8 218.1q-.1-.2-.1-.5v-.5l.2-.4q.1-.2.3-.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "M152.1 312.9c-2.5 0-4.6-2-4.6-4.5s2.1-4.6 4.6-4.6c2.5 0 4.5 2.1 4.5 4.6 0 2.5-2 4.5-4.5 4.5zM264.9 312.9c-2.5 0-4.6-2-4.6-4.5s2.1-4.6 4.6-4.6c2.5 0 4.5 2.1 4.5 4.6 0 2.5-2 4.5-4.5 4.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m192.5 312.1 56.7-36.3M152.1 308.4l30-32.8M182.1 275.6l-3.3-13.4M9.6 267.9l15.6-75.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M52.1 196.5c-1.6 1.5-5 6.7-6.5 6.7-4.5 0-18-8.2-18.9-10.5-.2-.6 1.4-2.2 1.8-2.2.5 0 8.3 4.7 13.2 4.3 2.6-.3 4.3-5.5 7.2-8.6M134.5 202.4c.3-.4 2.1-2.6 2.7-2.7 1.1-.2 5.5 4.1 5.5 4.5 0 .4-.2.9-.5.9s-2.5-1.3-2.9-1.3q-.3.1-.5.2-.3.1-.5.2l-.4.4-.4.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m70 215.7-21.2 21.8s4.4 28.1 3.6 28.9q-.5.3-1 .5-.6.2-1.1.3-.6.1-1.2.1l-1.2-.2c-.9-.6-12.4-26.8-12.4-30.2 0-3.5 14.3-30.7 15.7-32z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "M68.1 194.5c1.6.9 23.8 13.5 29.9 19.1 3.3-.9 36.1-12.3 36.5-12 .4.3 3.7 2.7 3.7 3.3 0 .6-33.6 27.5-42.7 27.5-3.3 0-35.1-18.6-44.3-27.5-1-5 12.6-13 16.9-10.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "M53.8 176.2c3.4-1.2 14.3 17.4 14.3 18.3 0 .8-15.4 10.5-17 10.4-1.5-.1-13-23.1 2.7-28.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M43.1 169.2c-.4 0-1.9-1.9-1.1-6.1 1-1.2 4.2-1.6 4.3-.2.1 1.4-1.8 6.4-3.2 6.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m49.1 175.2 4.5-.6.8 5.5c.1.9-4.4 1.4-4.5.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "M54.1 177.9c-.1-.5-1.4-2.1-2.3-1.7 1.1-.5 1.4-1.9 1.8-1.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M48.8 177.1c-3.3 0-5.9-2.7-5.9-6s2.6-5.9 5.9-5.9c3.3 0 6 2.6 6 5.9 0 3.3-2.7 6-6 6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "M43.1 173.1c-.6 0-1.1-.1-1.1-.4 0-.3.4-.6.9-.7.6 0 1 .1 1.1.4 0 .3-.4.6-.9.7zM49.2 172.4c-.5.1-1-.1-1-.4-.1-.3.3-.6.9-.6.5-.1 1 .1 1 .3.1.3-.3.6-.9.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "M45.2 171.3c-.1.3-.9 1.6.1 1.9M48.4 173.3q-.1.2-.2.3l-.2.2-.2.2q-.2.1-.3.2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M51 158.3c7.8 0 13.5 1.3 17.2 1.3 5.7 0 10.1-2.6 16.5-2.6 2.9 0 10.3 2.5 10.3 10.8 0 4.8-2.6 14.1-13.9 14.1-9.7 0-11.4-4-15.3-4-4.1 0-11.8 1.9-13.1-3.4q-.1-.6-.2-1.1-.1-.6-.3-1.2-.2-.5-.4-1.1-.2-.6-.4-1.1c-4.4-1.5-5.7-1.4-7.8-2.6-2.9-1.4-3.1-9.1 7.4-9.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M52.4 172.2c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.8 0 1.3.6 1.3 1.3 0 .7-.5 1.3-1.3 1.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M52.1 266.2c.1.5.9 3.3.6 3.8-.6 1-6.5 1.9-6.9 1.7-.3-.2-.6-.7-.4-1 .2-.2 2.4-1.2 2.7-1.5q.1-.2.2-.5.1-.2.1-.5v-.6q0-.3-.1-.5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "M16.2 274.4h61.2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m24.7 192 4.5-2.9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M26.1 192.4c-1.3 0-2.5-.7-2.5-1.4 0-.8 1.2-1.5 2.5-1.5 1.4 0 2.5.7 2.5 1.5 0 .7-1.1 1.4-2.5 1.4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "M24.2 194c-1.4 0-2.5-.6-2.5-1.4 0-.8 1.1-1.5 2.5-1.5s2.5.7 2.5 1.5-1.1 1.4-2.5 1.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m19.9 195 3.4-2.1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "M53.7 196.8c-1.5 1.5-8.1 7.7-9.7 7.7-4.4 0-17.9-8.2-18.8-10.5-.2-.6 1.3-2.2 1.8-2.2.4 0 10.1 5.1 14.9 4.6 2.6-.2 7.7-9.5 10.6-12.5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "M9.1 281.5c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1 0 3.9-3.2 7.1-7.1 7.1zM84.5 281.5c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1 0 3.9-3.2 7.1-7.1 7.1z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "M45.8 192.7c1.2-1.6 2.6-3.5 3.7-5.2M53.7 196.8c-.7.8-2.8 2.7-4.8 4.5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "M51.9 198.8c-.4.4-2.7 3.6-2 4.6-.9-1.6-1.1-2-1.1-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalent);
export default __webpack_public_path__ + "static/media/talent.5fa1858747204bb8906210c1f11eca25.svg";
export { ForwardRef as ReactComponent };